"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var fabric_1 = require("@aperza/fabric");
var PdfEditorProvider_1 = require("./PdfEditorProvider");
var PdfEditorFabricUtil_1 = require("./PdfEditorFabricUtil");
exports.PdfEditorCanvas = function () {
    var _a = PdfEditorProvider_1.usePdfEditorContext(), pageLoading = _a.pageLoading, pdfEditorCanvasMethodsRef = _a.pdfEditorCanvasMethodsRef, showEditor = _a.showEditor, pageNumber = _a.pageNumber, prevPageNumber = _a.prevPageNumber, setPrevPageNumber = _a.setPrevPageNumber, rotationAngle = _a.rotationAngle, prevRotationAngle = _a.prevRotationAngle, setPrevRotationAngle = _a.setPrevRotationAngle, pdfEditorViewDimension = _a.pdfEditorViewDimension, prevPdfEditorViewDimension = _a.prevPdfEditorViewDimension, setPrevPdfEditorViewDimension = _a.setPrevPdfEditorViewDimension, fabricDataMap = _a.fabricDataMap;
    var canvasDivElementRef = react_1.useRef(null);
    var canvasElementRef = react_1.useRef(null);
    var _b = react_1.useState(), fabricCanvas = _b[0], setFabricCanvas = _b[1];
    var _c = react_1.useState([]), copiedObjects = _c[0], setCopiedObjects = _c[1];
    var _d = react_1.useState(0), newStampOffsetCounter = _d[0], setNewStampOffsetCounter = _d[1];
    var hideCanvas = function () {
        if (canvasDivElementRef && canvasDivElementRef.current) {
            canvasDivElementRef.current.style.display = 'none';
        }
    };
    var showCanvas = function () {
        if (canvasDivElementRef && canvasDivElementRef.current) {
            canvasDivElementRef.current.style.display = 'block';
        }
    };
    /**
     * Without delay the renderAll may not be executed.
     * https://stackoverflow.com/questions/33529629/fabric-js-image-is-not-visible-on-canvas-until-selected
     * Otherwise, out of canvas stamp will not show after it has been processed by keepObjectVisible.
     */
    var updateCanvas = function () {
        if (fabricCanvas) {
            setTimeout(function () {
                fabricCanvas.renderAll();
            }, 25);
        }
    };
    var saveCurrentPage = function (_pageNumber) {
        if (_pageNumber > 0 && fabricCanvas) {
            var json = PdfEditorFabricUtil_1.exportFabricCanvasToJsonNoRotate(fabricCanvas, rotationAngle, pdfEditorViewDimension.width, pdfEditorViewDimension.height);
            fabricDataMap.setFabricData(_pageNumber, json);
        }
    };
    var loadFabricData = function (_pageNumber) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, width_1, height_1, json;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!fabricCanvas) return [3 /*break*/, 2];
                    fabricCanvas.clear();
                    _a = pdfEditorViewDimension, width_1 = _a.width, height_1 = _a.height;
                    json = fabricDataMap.getFabricData(_pageNumber);
                    if (!json) return [3 /*break*/, 2];
                    return [4 /*yield*/, new Promise(function (resolve) {
                            var fabricData = fabricDataMap.fabricData[pageNumber - 1];
                            fabricCanvas.loadFromJSON(fabricData, function () {
                                PdfEditorFabricUtil_1.setControlsVisibility(fabricCanvas);
                                if (!fabricData.fabricDataVersion) {
                                    console.log('fabricDataVersion is missing in fabricData. old version.');
                                }
                                if (fabricData.fabricDataVersion === 1) {
                                    var xScale = width_1 / (fabricData.dimensions.width || width_1);
                                    var yScale = height_1 / (fabricData.dimensions.height || height_1);
                                    PdfEditorFabricUtil_1.scaleObjects({ xScale: xScale, yScale: yScale, fabricCanvas: fabricCanvas, renderAll: true });
                                }
                                else {
                                    // If the stored fabricData has different rotate value.
                                    // For old fabricData format in unrotated positions. Always rotate clockwise.
                                    PdfEditorFabricUtil_1.rotateObjectsByAngleDelta({
                                        fabricCanvas: fabricCanvas,
                                        prevRotationAngle: 0,
                                        rotationAngle: fabricData.rotate,
                                        prevWidth: fabricData.dimensions.width,
                                        prevHeight: fabricData.dimensions.height,
                                        width: width_1,
                                        height: height_1,
                                        renderAll: true,
                                    });
                                }
                                resolve();
                            });
                        })];
                case 1:
                    _b.sent();
                    _b.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var processCanvas = function () { return __awaiter(void 0, void 0, void 0, function () {
        var prevDimension, prevAngle, xScale, yScale;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    prevDimension = prevPdfEditorViewDimension !== null && prevPdfEditorViewDimension !== void 0 ? prevPdfEditorViewDimension : pdfEditorViewDimension;
                    prevAngle = prevRotationAngle !== null && prevRotationAngle !== void 0 ? prevRotationAngle : rotationAngle;
                    if (!(fabricCanvas && pdfEditorViewDimension && prevDimension)) return [3 /*break*/, 4];
                    fabricCanvas.setWidth(pdfEditorViewDimension.width);
                    fabricCanvas.setHeight(pdfEditorViewDimension.height);
                    xScale = pdfEditorViewDimension.width / ((prevDimension === null || prevDimension === void 0 ? void 0 : prevDimension.width) || pdfEditorViewDimension.width);
                    yScale = pdfEditorViewDimension.height / ((prevDimension === null || prevDimension === void 0 ? void 0 : prevDimension.height) || pdfEditorViewDimension.height);
                    if (!(pageNumber !== prevPageNumber)) return [3 /*break*/, 2];
                    /**
                     * Immediately hide canvas if the pageNumber has changed.
                     * Canvas is showns after render event => after:render
                     */
                    hideCanvas();
                    saveCurrentPage(prevPageNumber);
                    return [4 /*yield*/, loadFabricData(pageNumber)];
                case 1:
                    _a.sent();
                    setPrevPageNumber(pageNumber);
                    return [3 /*break*/, 3];
                case 2:
                    if (rotationAngle !== prevRotationAngle) {
                        PdfEditorFabricUtil_1.rotateObjectsByAngleDelta({
                            fabricCanvas: fabricCanvas,
                            prevRotationAngle: prevAngle,
                            rotationAngle: rotationAngle,
                            prevWidth: prevDimension.width,
                            prevHeight: prevDimension.height,
                            width: pdfEditorViewDimension.width,
                            height: pdfEditorViewDimension.height,
                            renderAll: true,
                        });
                        setPrevRotationAngle(rotationAngle);
                    }
                    else {
                        PdfEditorFabricUtil_1.scaleObjects({ fabricCanvas: fabricCanvas, xScale: xScale, yScale: yScale, renderAll: true });
                    }
                    _a.label = 3;
                case 3:
                    setPrevPdfEditorViewDimension(pdfEditorViewDimension);
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    react_1.useEffect(function () {
        if (!pageLoading) {
            (function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, processCanvas()];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); })();
        }
    }, [JSON.stringify(pdfEditorViewDimension), rotationAngle, pageNumber, pageLoading]);
    var onObjectMoving = function (props) {
        setNewStampOffsetCounter(0);
        PdfEditorFabricUtil_1.keepObjectVisible(props.target);
    };
    var deleteEmptyText = function (options) {
        if (options.deselected) {
            var previousObject = options.deselected[0];
            if (previousObject.hasOwnProperty('text') && previousObject.text.trim().length === 0) {
                previousObject.canvas.remove(previousObject);
            }
        }
    };
    var addShadow = function (options) {
        var _a;
        (_a = options.selected) === null || _a === void 0 ? void 0 : _a.forEach(function (object) {
            object.shadow = new fabric_1.fabric.Shadow({
                color: 'rgba(0,0,0,0.3)',
                offsetX: 2,
                offsetY: 2,
                blur: 4,
            });
        });
    };
    var removeShadow = function (options) {
        var _a;
        (_a = options.deselected) === null || _a === void 0 ? void 0 : _a.forEach(function (object) {
            object.shadow = undefined;
        });
    };
    var deleteObject = function (event) {
        var _a, _b;
        if (event.keyCode === 46 || event.keyCode === 8) {
            // listens for delete or backspace keypress
            event.preventDefault();
            var activeObjects = fabricCanvas === null || fabricCanvas === void 0 ? void 0 : fabricCanvas.getActiveObjects();
            if (activeObjects) {
                (_b = (_a = activeObjects[0]) === null || _a === void 0 ? void 0 : _a.group) === null || _b === void 0 ? void 0 : _b.destroy(); // this fixes a bug in fabric where the objects in a group are not updated
                activeObjects.forEach(function (object) { return fabricCanvas === null || fabricCanvas === void 0 ? void 0 : fabricCanvas.remove(object); });
            }
        }
    };
    var copyPaste = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var activeObjects, clonedObjects;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!fabricCanvas)
                        return [2 /*return*/];
                    if (event.key === 'c' && (event.ctrlKey || event.metaKey)) {
                        event.preventDefault();
                        activeObjects = fabricCanvas.getActiveObjects();
                        if (activeObjects)
                            setCopiedObjects(activeObjects);
                    }
                    if (!(event.key === 'v' && (event.ctrlKey || event.metaKey))) return [3 /*break*/, 2];
                    event.preventDefault();
                    if (!(copiedObjects.length > 0)) return [3 /*break*/, 2];
                    (_a = copiedObjects[0].group) === null || _a === void 0 ? void 0 : _a.destroy(); // this fixes a bug in fabric where the objects in a group are not updated
                    return [4 /*yield*/, Promise.all(copiedObjects.map(function (object) {
                            return PdfEditorFabricUtil_1.cloneFabricObject(object);
                        }))];
                case 1:
                    clonedObjects = _b.sent();
                    clonedObjects.forEach(function (clonedObject) {
                        clonedObject.left = (clonedObject.left || 0) + 20;
                        clonedObject.top = (clonedObject.top || 0) + 20;
                        fabricCanvas.add(clonedObject);
                        fabricCanvas.setActiveObject(clonedObject);
                    });
                    _b.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var keyDownHandler = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            if (!fabricCanvas)
                return [2 /*return*/];
            if (((_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.nodeName) === 'INPUT' ||
                ((_b = document.activeElement) === null || _b === void 0 ? void 0 : _b.nodeName) === 'TEXTAREA') {
                // don't do anything if editing text
                return [2 /*return*/];
            }
            deleteObject(event);
            copyPaste(event);
            return [2 /*return*/];
        });
    }); };
    react_1.useEffect(function () {
        document.addEventListener('keydown', keyDownHandler);
        return function () {
            document.removeEventListener('keydown', keyDownHandler);
        };
    }, [fabricCanvas, copiedObjects]); // copyPaste relies on copiedObjects, so it must be watched
    react_1.useEffect(function () {
        if (!fabricCanvas) {
            var _fabricCanvas = new fabric_1.fabric.Canvas(canvasElementRef.current, {
                width: pdfEditorViewDimension === null || pdfEditorViewDimension === void 0 ? void 0 : pdfEditorViewDimension.width,
                height: pdfEditorViewDimension === null || pdfEditorViewDimension === void 0 ? void 0 : pdfEditorViewDimension.height,
            });
            _fabricCanvas.on('object:moving', onObjectMoving);
            _fabricCanvas.on('selection:updated', deleteEmptyText);
            _fabricCanvas.on('selection:cleared', deleteEmptyText);
            _fabricCanvas.on('after:render', showCanvas);
            _fabricCanvas.on('selection:created', addShadow);
            _fabricCanvas.on('selection:updated', addShadow);
            _fabricCanvas.on('selection:cleared', removeShadow);
            _fabricCanvas.on('selection:updated', removeShadow);
            setFabricCanvas(_fabricCanvas);
        }
    }, [canvasElementRef.current]);
    react_1.useImperativeHandle(pdfEditorCanvasMethodsRef, function () { return ({
        addPdfEditorObject: function (pdfEditorObject) {
            var newStampOffset = 20;
            if (fabricCanvas) {
                pdfEditorObject.getFabricObject().then(function (object) {
                    var scale = 1;
                    if (object.width && object.height && pdfEditorObject.scalePageRatio) {
                        scale =
                            (Math.min(fabricCanvas.getWidth(), fabricCanvas.getHeight()) /
                                Math.max(object.width, object.height)) *
                                pdfEditorObject.scalePageRatio;
                    }
                    object.scale(scale);
                    var stampLeft = fabricCanvas.getWidth() / 2 -
                        object.getScaledWidth() / 2 +
                        newStampOffsetCounter * newStampOffset;
                    var stampTop = fabricCanvas.getHeight() / 2 -
                        object.getScaledHeight() / 2 +
                        newStampOffsetCounter * newStampOffset;
                    object.set({ left: stampLeft, top: stampTop });
                    fabricCanvas.add(object);
                    if (pdfEditorObject.afterAddingFabricObject) {
                        pdfEditorObject.afterAddingFabricObject(fabricCanvas, object);
                    }
                    var modified = PdfEditorFabricUtil_1.keepObjectVisible(object);
                    if (modified) {
                        updateCanvas();
                    }
                    fabricCanvas.setActiveObject(object);
                    setNewStampOffsetCounter(newStampOffsetCounter + 1);
                });
            }
        },
        addFabricObject: function (fabricObject) {
            if (fabricCanvas) {
                fabricCanvas.add(fabricObject);
            }
        },
        getFabricDataMap: function () {
            saveCurrentPage(pageNumber);
            return fabricDataMap;
        },
    }); });
    return (react_1.default.createElement("div", { className: "w-100 h-100", style: {
            position: 'absolute',
            top: -0.5,
            left: -0.5,
            boxSizing: 'border-box',
            display: showEditor ? 'block' : 'none',
        } },
        react_1.default.createElement("div", { className: "w-100 h-100", ref: canvasDivElementRef },
            react_1.default.createElement("canvas", { style: {
                    backgroundColor: 'transparent',
                }, ref: canvasElementRef }))));
};
exports.PdfEditorCanvas.displayName = 'PdfEditorCanvas';
//# sourceMappingURL=PdfEditorCanvas.js.map